import {
  PiChartBarDuotone, PiBuildingsDuotone, PiPlusCircleDuotone, PiStackDuotone,
  PiUsersThreeDuotone, PiPlugsConnectedDuotone, PiGaugeDuotone, PiShieldCheckDuotone,
  PiGearSixDuotone, PiWhatsappLogoDuotone, PiChatsCircleDuotone,
} from "react-icons/pi";

export const MASTER_NAV = [
  { section: null, items: [{ to: "/master", label: "Dashboard", icon: PiChartBarDuotone, end: true }] },
  { section: "Merchants", items: [
    { to: "/master/merchants", label: "All Merchants", icon: PiBuildingsDuotone, perm: "merchant.view" },
    { to: "/master/merchants/new", label: "Create Merchant", icon: PiPlusCircleDuotone, perm: "merchant.create" },
  ]},
  { section: "Plans & Access", items: [
    { to: "/master/plans", label: "Plans, Modules & Limits", icon: PiStackDuotone, perm: "merchant.view" },
  ]},
  { section: "Platform Users", items: [
    { to: "/master/users", label: "Users & Roles", icon: PiUsersThreeDuotone, perm: "master.users.manage" },
  ]},
  { section: "Integrations", items: [
    { to: "/master/api-integrations", label: "API integrations", icon: PiPlugsConnectedDuotone, perm: "merchant.view" },
    { to: "/master/whatsapp", label: "Platform WhatsApp", icon: PiWhatsappLogoDuotone, perm: "merchant.whatsapp.manage" },
    { to: "/master/whatsapp/companions", label: "WhatsApp Companions", icon: PiChatsCircleDuotone, perm: "merchant.whatsapp.manage" },
    { to: "/master/integrations", label: "WhatsApp, AI, Email", icon: PiPlugsConnectedDuotone, perm: "merchant.whatsapp.manage" },
  ]},
  { section: "Operations", items: [
    { to: "/master/operations", label: "Health, DB, Domains", icon: PiGaugeDuotone, perm: "merchant.view" },
  ]},
  { section: "Security", items: [
    { to: "/master/security", label: "Audit & Support Access", icon: PiShieldCheckDuotone, perm: "master.audit.view" },
  ]},
  { section: "Settings", items: [
    { to: "/master/settings", label: "Platform Settings", icon: PiGearSixDuotone, perm: "platform.settings.manage" },
  ]},
];
